// extracted by mini-css-extract-plugin
export default {"customInput":"input_customInput__kiZyq"};